module.exports = __webpack_public_path__ + "img/RedBag_icon_white.9009525.svg";